import React from 'react';
import clsx from 'clsx';

const VARIANTS = {
  primary: 'bg-primary-500 text-black hover:bg-primary-600',
  secondary: 'bg-secondary-500 text-black hover:bg-secondary-600',
  danger: 'bg-danger-500 text-white hover:bg-danger-600',
  soft: 'bg-accent text-black hover:bg-accent-alt',
};

// Fully rounded stadium pill button (mockup buttons — full width, bold, no border).
export function PillButton({
  children,
  variant = 'primary',
  type = 'button',
  disabled = false,
  onClick,
  className = '',
  ...props
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        'w-full rounded-full px-6 py-3 text-lg font-bold transition-colors duration-200',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-700',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        VARIANTS[variant],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
